import React from "react";

export default function LoadingUser() {
  return (
    <h1 style={{ width: "100%", textAlign: "center", margin: "40px 20px" }}>
      Please wait while we log you in...
    </h1>
  );
}
